<div class="container-fluid px-0">
  <div class="row g-2 mb-3 align-items-end justify-content-between">
    <div class="col-md-6">
      <h5 class="mb-0 fw-bold">System Users</h5>
    </div>
    <div class="col-md-6 d-flex justify-content-end">
      <button class="btn btn-primary btn-sm" (click)="onAddUser()">
        <c-icon name="cil-user-follow" size="sm"></c-icon> Add User
      </button>
    </div>
  </div>
  <div class="d-flex align-items-center gap-3 mb-2">
    <span class="fw-bold">Total:</span>
  <span>{{ totalItems }}</span>
    <div class="d-flex align-items-center gap-2 ms-auto">
      <select class="form-select form-select-sm w-auto" [(ngModel)]="itemsPerPage" name="itemsPerPage" (change)="onItemsPerPageChange()">
        <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{ size }} / page</option>
      </select>
      <button class="btn btn-outline-primary btn-sm" [disabled]="activePage === 1" (click)="onPageChange(activePage - 1)">&larr;</button>
      <ng-container *ngFor="let page of [].constructor(totalPages); let idx = index">
        <button type="button" class="btn btn-sm" [ngClass]="{'btn-primary': activePage === (idx+1), 'btn-outline-primary': activePage !== (idx+1)}" (click)="onPageChange(idx+1)">{{ idx+1 }}</button>
      </ng-container>
      <button class="btn btn-outline-primary btn-sm" [disabled]="activePage === totalPages" (click)="onPageChange(activePage + 1)">&rarr;</button>
    </div>
  </div>
  <c-row>
    <c-col xs>
      <c-card class="card mb-4">
        <c-card-body class="c-body">
          <!-- Spinner shown while loading -->
          <div class="d-flex justify-content-center my-4" *ngIf="loading">
            <c-spinner class="text-black" variant="border" label="Loading..."></c-spinner>
          </div>
          <!-- Table shown when data is loaded and not empty -->
          <table cTable class="table table-hover w-100" *ngIf="!loading && users && users.length > 0; else noData">
            <thead class="table-header-full">
              <tr>
                <th class="align-middle">Status</th>
                <th class="align-middle">Email</th>
                <th class="align-middle">User Type</th>
                <th class="align-middle">First Name</th>
                <th class="align-middle">Last Name</th>
                <th class="align-middle">Date Added</th>
                <th class="align-middle">Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let user of users; let i = index">
                <tr>
                  <td>{{ user.status }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.user_type }}</td>
                  <td>{{ user.first_name }}</td>
                  <td>{{ user.last_name }}</td>
                  <td>{{ user.created_at | date:'yyyy-MM-dd' }}</td>
                  <td class="d-flex justify-content-center align-items-center gap-1">
                    <button class="btn btn-sm btn-outline-secondary" (click)="editUser(i)" title="Edit">
                      <c-icon name="cil-pencil" size="sm"></c-icon>
                    </button>
                    <button class="btn btn-sm btn-outline-primary" (click)="confirmSendPassword(user)" title="Send Password" [disabled]="sendingPassword[user.id]">
                      <c-icon name="cil-envelope-closed" size="sm"></c-icon>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <!-- Empty state message -->
          <ng-template #noData>
            <div class="alert alert-info text-center my-4" *ngIf="!loading">
              No users found
            </div>
          </ng-template>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</div>
